import { CalendarEvent } from '@/components/calendar/calendar.types';
import { EmployeeSchedule } from '@/services/employee/schedule/schedule.types';
import { SummaryAvailability } from '@/services/summary/summary.types';
import { useTasks } from '@/services/tasks/useTasks';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export interface ESSCalendarContextObject {
  hoverOnly?: boolean;
  shifts: SummaryAvailability[];
  availableTimes: SummaryAvailability[];
  leaveType?: string;
  patternStart?: number;
  patternEnd?: number;
  onClick: () => void;
}

export const useESSCalendarEvents = (data: EmployeeSchedule, onDayClick: (date: Date) => void) => {
  const navigate = useNavigate();
  const tasks = useTasks();

  return useMemo(() => {
    return Object.entries(data).map(([date, day]) => {
      const calendarEvent: CalendarEvent<ESSCalendarContextObject> = {
        date: new Date(date),
        contextObject: {
          shifts: day.shifts || [],
          availableTimes: day.availableTimes || [],
          leaveType: day.leaveType,
          patternStart: day.patternStart,
          patternEnd: day.patternEnd,
          hoverOnly: false,
          onClick: () => onDayClick(new Date(date))
        }
      };

      return calendarEvent;
    });
  }, [data, onDayClick]);
};
